module.exports = __webpack_public_path__ + "img/ico_type_input.e65dbdf6.svg";